import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { Heading } from '../Heading/Heading.es.js';

const IconStatusDefaultIcon = {
    info: 'InformationCircleSolid',
    success: 'CheckCircleSolid',
    warning: 'ExclamationSolid',
    error: 'XCircleSolid'
};
const Statement = ({ children, variant = 'component', status = 'info', title, titleAs = 'h3', padded = true, subtitle, iconName, loop, className, ...rest })=>{
    const defaultIconForStatus = status ? IconStatusDefaultIcon[status] : undefined;
    return jsxs(Heading, {
        alignment: "center",
        className: classNames('cb-statement', `cb-statement-${variant}`, {
            'cb-statement-padded': padded
        }, className),
        iconName: iconName ?? defaultIconForStatus,
        layout: "vertical",
        loop: loop,
        status: status,
        variant: variant === 'component' ? 'title/md' : 'section/md',
        ...rest,
        children: [
            title != null && jsx(Heading.Header, {
                as: titleAs,
                className: "copy",
                children: title
            }),
            subtitle != null && jsx(Heading.Intro, {
                as: "p",
                className: "copy description",
                children: subtitle
            }),
            children != null && jsx("div", {
                className: "cta",
                children: children
            })
        ]
    });
};
Statement.displayName = 'Statement';

export { Statement, Statement as default };
//# sourceMappingURL=Statement.es.js.map
